angular.
module("dx.webapp.sorting", [
	"dx.ui.components.localize",
]);
